var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('optional-feature-editor',{attrs:{"title":"複数行","description":"行数が複数行か否かを選択します。"},model:{value:(_vm.editingSource),callback:function ($$v) {_vm.editingSource=$$v},expression:"editingSource"}})}
var staticRenderFns = []

export { render, staticRenderFns }